module.exports = __webpack_public_path__ + "a5941083e863047d5d5921c9a30df4b1.md";